import { useQuery } from 'react-query';
import { statsByWeekQuery } from './useStatsByWeek.query';
import { UseStatsByWeekOptions } from './useStatsByWeek.types';
import {
  StatsByWeekRequestData,
  StatsResultsResponseRow,
} from '../../../types/api/endpoints/stats/results.types';

export const STATS_RESULTS_BY_WEEK_QUERY_KEY = 'STATS_RESULTS_BY_WEEK';

export const useStatsByWeek = (data: StatsByWeekRequestData, options?: UseStatsByWeekOptions) => {
  return useQuery<StatsResultsResponseRow[], Error>(
    [STATS_RESULTS_BY_WEEK_QUERY_KEY, data],
    () => statsByWeekQuery(data),
    options
  );
};
